import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'calcucateRssPosition',
  standalone: true
})
export class CalcucateRssPositionPipe implements PipeTransform {
  maxPercent = 100;

  transform(scrollValue: number, monitorHeight: number, rssHeigth: number): string {
    const rssBlockHeightPercent = this.maxPercent * (rssHeigth / monitorHeight);
    const availableHeight = this.maxPercent - rssBlockHeightPercent;
    return `${ (scrollValue / this.maxPercent) * availableHeight }%`;
  }

}
